import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPromotions, handleShowVerifiedProfileStepsModal } from '../actions/commission-scheme-actions';
import commissionSchemeConstants from '../constants/commission-scheme-constants';
import Helpers from '../../../../common/helpers';
import VerifiedProfileStepsModal from './verified-profile-steps-modal';
import TradingActivityTable from './trading-activity-table';
import CommissionTable from './commission-table';
import RenderIf from '../../../shared/render-if/components/render-if';

import '../styles/commission-scheme-other.css';

class CommissionSchemeAffiliate extends Component {
  componentDidMount() {
    const { getPromotions } = this.props;

    getPromotions();
  }

  getLink() {
    const { profile } = this.props;

    return `https://app.nagatrader.com/user-profile/${profile.user_id}/achievements`;
  }

  renderParagraphs(paragraphs) {
    const { t } = this.context;

    if (paragraphs && paragraphs.length > 0) {
      return paragraphs.map((item, index) => {
        return (
          <div className="display-flex" key={index}>
            <p className="commission-scheme-other__content commission-scheme-other__content--small">{t(item.label || '')}</p>
            <RenderIf if={item.link || item.full_profile}>
              <a href={item.full_profile ? this.getLink() : item.link} target="_blank" className="commission-scheme-other__content commission-scheme-other__content--small m-l-5">
                {t('COMMON.HERE')}
              </a>
            </RenderIf>
            <RenderIf if={item.action && item.openInfoModal}>
              <a className="commission-scheme-other__content commission-scheme-other__content--small m-l-5" onClick={() => this.openProfileBadgeModal()}>
                {t('COMMON.HERE')}
              </a>
            </RenderIf>
          </div>
        );
      });
    } else return null;
  }

  openProfileBadgeModal() {
    const { handleShowVerifiedProfileStepsModal } = this.props;

    handleShowVerifiedProfileStepsModal(true);
  }

  render() {
    const { t } = this.context;
    const { profile, promotions } = this.props;
    const userType = t(Helpers.getUserType(profile));

    return (
      <div className="commission-scheme-affiliate">
        <p className="commission-scheme-other__title">{t('COMMISSION_SCHEME.TITLE', { type: userType })}</p>
        <TradingActivityTable promotions={promotions} />
        <CommissionTable promotions={promotions} />
        {this.renderParagraphs(commissionSchemeConstants.affiliate_table_paragraphs)}
        <VerifiedProfileStepsModal />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  promotions: state.commissionSchemeReducer.promotions,
  profile: state.userProfileReducer.profile,
});

const mapDispatchToProps = dispatch => ({
  getPromotions: () => {
    dispatch(getPromotions());
  },
  handleShowVerifiedProfileStepsModal: data => {
    dispatch(handleShowVerifiedProfileStepsModal(data));
  },
});

CommissionSchemeAffiliate.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionSchemeAffiliate);



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-scheme-affiliate.js